import {
    LOAD_FREELANCERS_PAYROLL,
    LOADED_FREELANCERS_PAYROLL_SUCCESS,
    LOADED_FREELANCERS_PAYROLL_ERROR,
} from '../actions/Payroll';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: undefined,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_FREELANCERS_PAYROLL:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOADED_FREELANCERS_PAYROLL_SUCCESS:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case LOADED_FREELANCERS_PAYROLL_ERROR:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        default:
            return state;
    }
};

export default reducer;
